export default __webpack_public_path__ + "static/media/profile-icon.ea333606.png";